<script>
    export let showGraphModal; // boolean

    let dialogGraph; // HTMLDialogElement

    $: if (dialogGraph && showGraphModal) dialogGraph.showModal();

    import {
        ButtonGroup,
        Card,
        CardBody,
        CardHeader,
        CardFooter,
    } from "@sveltestrap/sveltestrap";
    import { Line } from "svelte-chartjs";
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        PointElement,
        CategoryScale,
    } from "chart.js";

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        PointElement,
        CategoryScale
    );

    export let matchs = [];
    export let classifs;

    let modesclassif=[];
    export let joueurs;
    export let season;

    let dimMD = "col-lg-5 col-xl-5 col-xxl-4 col-sm-9 col-md-9 col-9";
    let dimCat = "col-lg-5 col-xl-5 col-xxl-4 col-sm-9 col-md-9 col-9";
    let dimMS = "col-lg-1 col-xl-1 col-xxl-1 col-sm-3 col-md-3 col-3";
    let dimSaison = "col-lg-1 col-xl-1 col-xxl-1 col-sm-3 col-md-3 col-3";

    let format = ["3m10", "2m80"];

    let selFormat = '';

    // console.log(classifs)
    
    modesclassif = Object.keys(matchs)
    // console.log(modesclassif)
    
    // let mdCategories = {
    //     "Cadre 71/2": ["Masters"],
    //     "Cadre 47/2": ["Masters", "N1", "N2"],
    //     "Cadre 42/2": ["N3", "R1"],
    //     Libre: ["Masters", "N1", "N3", "R1", "R2", "R3", "R4"],
    //     "1 Bande": ["Masters", "N1", "N3", "R1", "R2"],
    //     "3 Bandes": ["Masters", "N1", "N2", "N3", "R1", "R2"],
    // };

    let selCategorie = 'toto';
    // let selCategorie = classifs[modesclassif[0]][3];
   
    let selMD = modesclassif[0];
        
    let oldselMD = ""

    // let curCategories = mdCategories[selMD];

    let mgserie = ["Moyenne", "Série"];
    let selmgserie = "Moyenne";

    let gp = ["G", "P"];
    let selgp = "G";
    let yValue;
    let chartTitle;

    let options = {};

    let data = {
        labels: [],
        datasets: [
            
            {
                label: "",
                fill: true,
                lineTension: 0.3,
                backgroundColor: "rgba(184, 185, 210, .3)",
                borderColor: "rgb(0, 0, 0)",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                // pointBorderColor: "rgb(0,0, 0)",
                pointBackgroundColor: "rgb(255, 255, 255)",
                pointBorderColor: function(context) {
                    var index = context.dataIndex;
                    var value = matchs[selMD][index][2];
                    return value == 'G' ? 'red' :  // draw negative values in red
                        value == 'P' ? 'blue' :    // else, alternate values in blue and green
                            'lightgreen';
                },
                pointBorderWidth: 6,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "rgb(0, 0, 0)",
                pointHoverBorderColor: "rgba(220, 220, 220, 1)",
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: [],
            },
        ],
    };

    // console.log(mdData);
    // console.log(matchs);

    $: {
        // curCategories = mdCategories[selMD];
        // if (!mdCategories[selMD].includes(selCategorie))
        // if (selMD != oldselMD)
        //     selCategorie = classifs[selMD][3];
        
        if (oldselMD!=selMD)
            if (!classifs[selMD])
                selFormat="2m80"
            else 
                classifs[selMD][3]=="Masters" || classifs[selMD][3]=="N1" || classifs[selMD][3]=="N2" || classifs[selMD][3]=="NC"
                    ? selFormat="3m10"
                    : selFormat="2m80"

        oldselMD=selMD 
       
        let i = 0;
        if (selmgserie == "Moyenne") {
            // if(selgp=="G") {
            // data.datasets[0].label = "Moyenne des Perdants";
            // data.datasets[1].label = "Moyenne des Gagnants";
            // }
            // else {
            //    data.datasets[0].label="Moy des Perdants"
            //   data.datasets[1].label="Meilleure Moy des Perdants"
            // }

            data.labels = [];
            data.datasets[0].data = [];
            // data.datasets[1].data = [];
            // data.datasets[2].data = [];

            data.datasets[0].label = "Moyenne du Joueur";
            matchs[selMD].forEach((m) => {
                i++;
                data.labels.push(i);
                // data.datasets[0].data.push(
                //     mdData[selMD][selCategorie].MG.perdant.moyenne
                // );
                // data.datasets[1].data.push(
                //     mdData[selMD][selCategorie].MG.gagnant.moyenne
                // );
                // selCategorie == "Masters" ||
                // selCategorie == "N1" ||
                // selCategorie == "N2"
                //     ? data.datasets[2].data.push(m[17])
                //     : data.datasets[2].data.push(m[16]);

                selFormat == "3m10" 
                    ? data.datasets[0].data.push(m[17])
                    : data.datasets[0].data.push(m[16])
            });
            // yValue = mdData[selMD][classifs[selMD][3]].MG.gagnant.moyenne;
        } else {
            // if(selgp=="G") {
            // data.datasets[0].label = "Moyenne des MS des Perdants";
            // data.datasets[1].label = "Moyenne des MS des Gagnants";
            // }
            // else {
            //    data.datasets[0].label="Moyenne des MS des Perdants"
            //   data.datasets[1].label="Meilleure MS des Perdants"
            // }

            data.labels = [];
            data.datasets[0].data = [];
            // data.datasets[1].data = [];
            // data.datasets[2].data = [];

            data.datasets[0].label = "MS du Joueur";
            matchs[selMD].forEach((m) => {
                i++;
                data.labels.push(i);
                // data.datasets[0].data.push(
                //     mdData[selMD][selCategorie].Serie.perdant.moyenne
                // );
                // data.datasets[1].data.push(
                //     mdData[selMD][selCategorie].Serie.gagnant.moyenne
                // );
                // selCategorie == "Masters" ||
                // selCategorie == "N1" ||
                // selCategorie == "N2"
                //     ? data.datasets[2].data.push(m[19])
                //     : data.datasets[2].data.push(m[18]);
                selFormat =="3m10" 
                    ? data.datasets[0].data.push(m[19])
                    : data.datasets[0].data.push(m[18])
            });
            // yValue = mdData[selMD][classifs[selMD][3]].Serie.gagnant.moyenne;
        }
        chartTitle =
            selMD + " " + selCategorie + " " + selmgserie + " " + selgp;
        options = {
            responsive: true,
            plugins: {
                // title: {
                //     display: true,
                //     text: chartTitle
                // },
                tooltip: {
                    callbacks: {
                        footer: extraContent,
                    },
                },
            },
            scales: {
                y: {
                    suggestedMin: 50,
                    // suggestedMax: yValue * 1.05,
                },
            },
        };
    }

    const extraContent = (tooltipItems) => {
        let ind = tooltipItems[0].label - 1;
        let msg =
            matchs[selMD][ind][3] +
            " en " +
            matchs[selMD][ind][4] +
            ", MS=" +
            matchs[selMD][ind][5] +
            " Moy=" +
            matchs[selMD][ind][6] +
            " sur [" + matchs[selMD][ind][13] + "]"

        let adv = joueurs[matchs[selMD][ind][7]];
        let res = matchs[selMD][ind][2];
        res == "G"
            ? (msg += " gagné vs " + adv)
            : res == "P"
              ? (msg += " perdu vs " + adv)
              : (msg += " nul vs " + adv);
        return msg;
    };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<dialog
    bind:this={dialogGraph}
    on:close={() => (showGraphModal = false)}
    on:click|self={() => dialogGraph.close()}
>
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div on:click|stopPropagation>
        <!-- <Card>
			<CardHeader> -->
        <div class="row">
            <div class={dimMD}>
                <ButtonGroup>
                    {#each modesclassif as md}
                        {#if md != "Cadre 47/1"}
                            <input
                                type="radio"
                                class="btn-check"
                                name="selMD"
                                value={md}
                                id={md}
                                bind:group={selMD}
                            />
                            <label
                                for={md}
                                class="btn btn-outline-success competitionButton"
                            >
                                {md}
                            </label>
                        {/if}
                    {/each}
                </ButtonGroup>
            </div>
            <div class={dimSaison}><h3>{season}</h3></div>

        </div>
        <div class="row">
            <div class={dimCat}>
             <ButtonGroup>
                    {#each format as f}
                        <input type="radio" class="btn-check" name="selformat" value={f} id={f} bind:group={selFormat} />
                        <label for={f} class="btn btn-outline-success competitionButton">
                            {f}
                        </label>
                    {/each}
                </ButtonGroup>
            </div>
            <div class={dimMS}>
                <ButtonGroup>
                    {#each mgserie as m}
                        <input
                            type="radio"
                            class="btn-check"
                            name="selmgserie"
                            value={m}
                            id={m}
                            bind:group={selmgserie}
                        />
                        <label
                            for={m}
                            class="btn btn-outline-success competitionButton"
                        >
                            {m}
                        </label>
                    {/each}
                </ButtonGroup>
            </div>
        </div>
        <hr />
        <!-- </CardHeader>  -->
        {#key [data]}
            <!-- <CardBody> -->
            <div style="height: 75vh; width:85vw" class="center">
                <Line {data} {options} />
            </div>
            <!-- </CardBody>   -->
        {/key}
        <!-- </Card>		 -->
    </div>
</dialog>

<style>
    .center {
        text-align: center;
        display: flex;
        /* //flex-flow: column; */
        justify-content: center;
    }
    dialog {
        /* max-width: 32em; */
        width: 90%;
        height: 95%;
        border-radius: 0.2em;
        border: none;
        padding: 0;
    }
    dialog::backdrop {
        background: rgba(0, 0, 0, 0.3);
    }
    dialog > div {
        padding: 1em;
    }
    dialog[open] {
        animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    @keyframes zoom {
        from {
            transform: scale(0.95);
        }
        to {
            transform: scale(1);
        }
    }
    dialog[open]::backdrop {
        animation: fade 0.2s ease-out;
    }
    @keyframes fade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    button {
        display: block;
    }

    label {
        font-size: 0.8em;
        padding: 3px;
        margin-top: 4px;
    }
    .btn-check {
        font-size: 0.8em;
        padding: 2px;
        margin: 0px;
    }
</style>
